import { Alert, AlertTitle, Box, FormControl, Stack, Typography } from '@mui/material'
import { useController } from '../hooks/useController'
import { useControllerActions } from '../hooks/useControllerActions'
import { useTerritoryDropdownItems } from '../hooks/useTerritoryDropdownItems'
import { useWarningCardData } from '../hooks/useWarningCardData'
import { useTexts } from '../useTexts'
import { SimpleSelect } from '@workwave-tidal/core/components'

export function Body() {
  const texts = useTexts()
  const handlers = useControllerActions()
  const {
    invalid,
    data: { territories, id },
  } = useController()

  const dropdownItems = useTerritoryDropdownItems(territories, id)
  const { title, description } = useWarningCardData(territories[id])

  return (
    <Stack marginTop={4} width="100%" minHeight={200}>
      <Box mb={2} width="100%">
        <Typography variant="subtitle1" color="text.secondary" sx={{ textTransform: 'uppercase' }}>
          {texts.territoryDropdownTitle}
        </Typography>
      </Box>

      <FormControl sx={{ mb: 4 }} fullWidth>
        <SimpleSelect
          value={id || ''}
          onChange={e => handlers.onTerritoryChange({ id: e.target.value })}
          disabled={!dropdownItems || invalid}
          displayEmpty
          options={
            dropdownItems?.map(item => ({
              value: item.id,
              label: item.label,
            })) || []
          }
          testId="copy-reasons-for-not-completed-orders-modal-territory-select"
        />
      </FormControl>

      <Alert severity="warning">
        <AlertTitle>{title}</AlertTitle>
        {description}
      </Alert>
    </Stack>
  )
}
